import { render } from "./CRMWhatsappConversationDialog.vue?vue&type=template&id=63a956f1"
import script from "./CRMWhatsappConversationDialog.vue?vue&type=script&lang=js"
export * from "./CRMWhatsappConversationDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__